/**
 * `galleries` — une galerie, un locataire (base plateforme, 4.1).
 *
 * Une galerie possède sa propre base Mongo, `artosera_g_<slug>` (D1).
 */
import { z } from 'zod';
import { moduleOptionnelSchema, palierSchema, quotasSchema } from '../modules.js';
import { CHAMPS_DOCUMENT, idSchema, langueSchema, slugSchema, withAudit } from './commun.js';
/**
 * État d'une galerie dans la console. `purge_en_cours` : la barrière durable
 * de la purge d'une galerie résiliée (ARTO-54) — elle ne se quitte que vers
 * `purgee`, l'état final, une fois toutes les étapes menées.
 */
export const ETATS_GALERIE = [
    'provisionnement',
    'active',
    'suspendue',
    'resiliee',
    'purge_en_cours',
    'purgee',
];
export const etatGalerieSchema = z.enum(ETATS_GALERIE);
export const gallerySchema = withAudit(z.object({
    _id: idSchema,
    slug: slugSchema,
    nom: z.string(),
    groupeId: idSchema.optional(),
    base: z.string().regex(/^artosera_g_[a-z0-9-]+$/, 'Nom de base attendu : artosera_g_<slug>.'),
    /** Préréglage commercial et quotas : ne décide plus des modules (D21). */
    palier: palierSchema,
    /**
     * La liste EXPLICITE des modules complémentaires activés (D21) : elle
     * fait foi. Le cœur n'y figure jamais, il est à tout le monde.
     */
    modulesActifs: z.array(moduleOptionnelSchema).default([]),
    quotas: quotasSchema.optional(),
    langueParDefaut: langueSchema.default('fr'),
    domainePrincipal: z.string().optional(),
    etat: etatGalerieSchema.default('provisionnement'),
    /**
     * Espace de TEST (lot B) : il n'entre dans aucun chiffre de pilotage ni de
     * facturation — vue d'aigle, photo de nuit, abonnements, créances. Posé à
     * la création ; changé ensuite par la direction de Venio seule.
     */
    estTest: z.boolean().default(false),
    /** Accès de support accordé par la direction, limité à 24 h (D14). */
    accesSupportJusquau: z.date().optional(),
}));
export const galleryCreationSchema = gallerySchema.omit({ ...CHAMPS_DOCUMENT, base: true });
export const galleryMiseAJourSchema = galleryCreationSchema.partial();
/** Le nom de la base d'une galerie se déduit de son slug (D1). */
export function baseDeLaGalerie(slug) {
    return `artosera_g_${slug}`;
}
//# sourceMappingURL=galleries.js.map